import styled from 'styled-components'

import { BREAKPOINT } from '../../design/breakpoint.constant'
import { HeadingXL, SmallText, BodyBold, TextLink } from '../../component-library/design/typography/typography.styles'
import { FONT_SIZE, FONT_REGULAR } from '../../component-library/design/typography/typography.constants'
import { COLOR } from '../../component-library/design/color/color.constants'
import { SPACING } from '../../component-library/design/spacing/spacing.constants'
import { Waypoint } from '../../component-library/components/waypoint/waypoint.component'
import { WaypointContentWrapper } from '../../component-library/components/waypoint/waypoint.styles'
import { Button } from '../../component-library/components/button/button.component'
import { AutoComplete } from '../../component-library/components/autocomplete/autocomplete.component'

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    width: 50%;
  }
`

const InnerContainer = styled.div`
  width: 100%;
  max-width: 352px;
  padding: 0 ${SPACING.M};

  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    width: 352px;
    max-width: 100%;
    padding: 0;
  }
`

const Title = styled(HeadingXL)``

const Info = styled.div`
  display: flex;
  ${FONT_REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  margin-bottom: ${SPACING.S};
  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    margin-bottom: ${SPACING.L};
  }
`

const MoreWaypoints = styled(SmallText)`
  color: ${COLOR.BLACK};
  margin: 0;
`

const DownloadAppLink = styled(TextLink)`
  margin-left: ${SPACING.XXS};
  line-height: 16px;
`

const StyledWaypoint = styled(Waypoint)`
  ${WaypointContentWrapper} {
    padding-bottom: 0;
  }

  &:last-of-type{
    margin-bottom: ${SPACING.XS};
    @media screen and (min-width: ${BREAKPOINT.TABLET}) {
      margin-bottom: 0;
    }
  }
`

const WaypointAnchor = styled(BodyBold)`
  margin: 0;
`

const ButtonEstimate = styled(Button)`
  padding: ${SPACING.S};
  margin-left: ${SPACING.XL};
`

const StyledAutocomplete = styled(AutoComplete)`
  margin-top: ${SPACING.XS};
`

export {
  Container,
  InnerContainer,
  Title,
  Info,
  MoreWaypoints,
  DownloadAppLink,
  StyledWaypoint,
  WaypointAnchor,
  ButtonEstimate,
  StyledAutocomplete,
}
